import { Text } from '../Text/index.js'
import { Icon, IconProps } from '../Icon/index.js'
import { Stack } from '../Stack/index.js'
import { Button } from '../Button/index.js'
import { capitalize, splitByUppercase } from '../../utils/text.js'

export type Tabs = {
  value: string
  label?: string
  icon?: IconProps['variant']
  disabled?: boolean
}

export type TabsProps = {
  value?: string
  onChange: (value: string) => void
  tabs: Tabs[]
}

export function Tabs({ tabs, value: activeValue, onChange }: TabsProps) {
  return (
    <Stack gap={8} align="start">
      {tabs.map(
        ({
          value,
          label = capitalize(splitByUppercase(value)),
          icon,
          disabled,
        }) => {
          if (!value) {
            return null
          }

          return (
            <Button
              key={value}
              disabled={disabled}
              variant="ghost"
              forceHover={value === activeValue ? true : false}
              onClick={() => onChange(value)}
            >
              {icon ? (
                <Icon
                  size="regular"
                  variant={icon}
                  style={{ marginRight: 4 }}
                />
              ) : null}
              <Text
                selectableText={false}
                variant="display-medium"
                color="inherit"
              >
                {label}
              </Text>
            </Button>
          )
        },
      )}
    </Stack>
  )
}
